/* eslint-disable react/no-unstable-nested-components */
import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Table } from "@jhool-io/fe-components";
import { IClientMedication } from "../../types/e-prescribe.types";
import {
    displayNameInRightFormat,
    formatDate,
} from "../../../../utils/helpers";
import { getStatusForDisplay } from "../../helpers/e-prescribe.helpers";

interface ClientMedicationListTableProps {
    data: IClientMedication[];
}

export default function ClientMedicationListTable({
    data,
}: ClientMedicationListTableProps) {
    const columns: ColumnDef<IClientMedication>[] = useMemo(() => {
        return [
            {
                accessorKey: "medication_name",
                header: "Medication Name",
                cell: ({ row }) => (
                    <span className="capitalize">
                        {row.original.medication_name ?? "--"}
                    </span>
                ),
            },
            {
                accessorKey: "dosage",
                header: "Dosage",
                cell: ({ row }) => row.original.dosage ?? "--",
            },
            {
                accessorKey: "frequency",
                header: "Frequency",
                cell: ({ row }) => row.original.frequency ?? "--",
            },
            {
                accessorKey: "prescriber",
                header: "Prescriber",
                cell: ({ row }) => {
                    if (row.original.prescriber) {
                        return displayNameInRightFormat(
                            row.original.prescriber
                        );
                    }
                    return "--";
                },
            },
            {
                accessorKey: "status",
                header: "Status",
                cell: ({ row }) => (
                    <span>{getStatusForDisplay(row.original.status)}</span>
                ),
            },
            {
                accessorKey: "start_date",
                header: "Start Date",
                cell: ({ row }) =>
                    row.original.start_date
                        ? formatDate(row.original.start_date, true)
                        : "--",
            },
            {
                accessorKey: "end_date",
                header: "End Date",
                cell: ({ row }) =>
                    row.original.end_date
                        ? formatDate(row.original.end_date, true)
                        : "--",
            },
            {
                accessorKey: "created_at",
                header: "Date Added",
                cell: ({ row }) =>
                    row.original.created_at
                        ? formatDate(row.original.created_at)
                        : "--",
            },
        ];
    }, []);
    return <Table data={data} columns={columns} />;
}
